import { render, staticRenderFns } from "./PopupCreateOrUpdateAccessory.vue?vue&type=template&id=a736d0f6&"
import script from "./PopupCreateOrUpdateAccessory.vue?vue&type=script&lang=js&"
export * from "./PopupCreateOrUpdateAccessory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/locales/modules/DeviceAccessoryTranslate.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Flike%2FDocuments%2FComay%2FSources%2FFe%2Flink-fe%2Fsrc%2Fviews%2Fapps%2Fcbs%2Fdevice%2FPopupCreateOrUpdateAccessory.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports